export {seconds2Hours} from 'utils/vue/lib/formatters'
import dates from 'utils/vue/lib/dates'
export * from 'utils/vue/lib/dates'
export default dates
